export interface ParsedCsvContent {
	[key: string]: string;
}
